module.exports = __webpack_public_path__ + "static/kdb-banner-2@2x-2205092b42c4049848cd8ac81c19f763.png";